// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2QuD7","row":"ProcedureTreatmentSummary_row__1v-p7"};